
export default {
  name: 'navBtn',
  props: {
    path: String,
    activeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // isActive: true
    }
  },
  computed: {
    isActive () {
      // console.log(this.$route.path.indexOf(this.path))
      // console.log(this.$route.path)
      return this.$route.path.indexOf(this.path) !== -1

      // -1 是index里面的false
    },
    activeStyle () {
      return this.isActive ? { color: this.activeColor } : { }
    }
  },
  methods: {
    itemclick () {

    }
  }
}
